let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6u1HZ")).then(() => parcelRequire('el3Ev'));